import { useQuery } from "@tanstack/react-query";
import VerifyComplianceService from "@/services/verify-compliance/verify-compliance.service";
import type {
  VerifyComplianceDetails,
  VerifyComplianceSearchResult,
} from "@/models/responses/verify-compliance/verify-compliance.response";

// Search approved companies by name or RC number. Disabled until the query is
// at least 2 characters (mirrors the backend's minimum).
export const useSearchCompanies = (query: string) => {
  const term = query.trim();
  return useQuery<VerifyComplianceSearchResult[]>({
    queryKey: ["verify-compliance-search", term],
    queryFn: () => VerifyComplianceService.search(term),
    enabled: term.length >= 2,
    staleTime: 60 * 1000,
  });
};

// Fetch a single company's compliance verification details.
export const useCompanyComplianceDetails = (employerCode: string | null) => {
  return useQuery<VerifyComplianceDetails>({
    queryKey: ["verify-compliance-details", employerCode],
    queryFn: () => VerifyComplianceService.getDetails(employerCode as string),
    enabled: !!employerCode,
    staleTime: 60 * 1000,
  });
};
